// window.Url = Url;

const isGW = response => {
  return response.hasOwnProperty('status');
};

/**
 *
 * @param request {Json}
 * @param reject
 * @param rootAddress
 * @return {{
 *   getAccountState
 * }}
 */
export default function (request, reject, rootAddress) {
  var service = {};
  /**
   获得基本信息
   请求方法: GET, POST
   请求示例: http://<domain>/webapp/mbsubscribe231101/get_config

   响应示例:

   {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "total": 0,
          "session_id": "QMthOsoLw4TteWJzdMupD4Kd80wtf43Mdi6SPnvn",
          "request_id": "8a20adba570042c127b8622cdcfa671bb67d26d1"
      }
   }
   */
  service.getConfig = function () {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/get_config', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
         {
          "data{}": {
            "total": "预约总数"
          }
        }
         */
        return response.data;
      }
      /**
       [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }]
       */
      return reject(response);
    });
  };
  /**
   发送邮件验证码
   请求方法: GET, POST
   请求示例: http://<domain>/webapp/mbsubscribe231101/get_email_code?email=495794424@qq.com&lang=cht

   响应示例:

   {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "session_id": "QMthOsoLw4TteWJzdMupD4Kd80wtf43Mdi6SPnvn",
          "request_id": "c1a8dcce88a4ad66ba789effb49e503b2cacd50b"
      }
   }
   */
  service.getEmailCode = function (params) {
    return request
      .post(rootAddress + '/webapp/mbsubscribe231101/get_email_code', {
        ...params
        // email: email /*  邮箱 */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
           {
          "data{}": []
        }
           */
          return response.data;
        }
        /**
         [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10103",
        "description": "邮箱为空"
      }, {
        "code": "-10104",
        "description": "邮箱格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "邮箱格式错误"
      }, {
        "code": "-20102",
        "description": "该邮箱已预约"
      }]
         */
        return reject(response);
      });
  };
  /**
   预约
   请求方法: GET, POST
   请求示例: http://<domain>/webapp/mbsubscribe231101/subscribe?email=495794424@qq.com&code=456123

   响应示例:

   {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "session_id": "QMthOsoLw4TteWJzdMupD4Kd80wtf43Mdi6SPnvn",
          "request_id": "ca8f5850a1a856d47aea2b926d5a58dbd6788335"
      }
   }
   */
  service.subscribe = function (params) {
    return request
      .post(rootAddress + '/webapp/mbsubscribe231101/subscribe', {
        email: params.email /*  邮箱 */,
        code: params.code /*  邮箱验证码 */,
        utm_source: params.utm_source /*  邮箱验证码 */,
        pass_check: params.pass_check,
        subscribe_duration_time: params.subscribe_duration_time // 预约经历时间
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
           {
          "data{}": []
        }
           */
          return response.data;
        }
        /**
         [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20102",
        "description": "该邮箱已预约"
      }]
         */
        return reject(response);
      });
  };
  service.downloadStatus = function () {
    return request.post(rootAddress + '/webapp/mbsubscribe231101/download_status', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": []
        }
            */
        return response.data;
      }

      return reject(response);
    });
  };
  service.getCountdownMsg = function () {
    return request.post(rootAddress + '/webapp/cbdlcyr241107/get_countdown_msg', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "bottom_left_red_point_delay_seconds": "下左红点延迟秒数",
            "bottom_right_red_point_delay_seconds": "下右红点延迟秒数",
            "countdown": "倒计时剩余总秒数",
            "countdown_doubling": "倒计时倍数",
            "is_begin": "是否已经开始",
            "red_point_delay_seconds": "红点再现延迟秒数",
            "top_left_red_point_delay_seconds": "上左红点延迟秒数",
            "top_min_red_point_delay_seconds": "上中红点延迟秒数",
            "top_right_red_point_delay_seconds": "上右红点延迟秒数"
          }
        }
            */
        return response.data;
      }
      return reject(response);
    });
  };
  service.getCountdownMsg = function () {
    return request.post(rootAddress + '/webapp/cbdlcyr241107/get_countdown_msg', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "bottom_left_red_point_delay_seconds": "下左红点延迟秒数",
            "bottom_right_red_point_delay_seconds": "下右红点延迟秒数",
            "countdown": "倒计时剩余总秒数",
            "countdown_doubling": "倒计时倍数",
            "is_begin": "是否已经开始",
            "red_point_delay_seconds": "红点再现延迟秒数",
            "top_left_red_point_delay_seconds": "上左红点延迟秒数",
            "top_min_red_point_delay_seconds": "上中红点延迟秒数",
            "top_right_red_point_delay_seconds": "上右红点延迟秒数"
          }
        }
            */
        return response.data;
      }
      return reject(response);
    });
  };
  service.area = '';
  service.getArea = function () {
    if (service.area) {
      return Promise.resolve(service.area);
    }
    return request.post('//pl-api.amazingseasun.com/webapp/official/proxy?uri=seasun/ext/getIpArea', {}).then(data => {
      service.area = data.data.areacode;
      return data.data.areacode;
    });
  };
  return service;
}
